module.exports = "/_next/static/images/loading_image-4761dcea6c16057bcfc9f385ead6c473.png";